export const dongleUserTableScheme = [
  {
    prop: 'name',
    label: '加密狗唯一编号 ',
    minWidth: 80
  },
  {
    prop: 'clinicName',
    label: '门诊名称 ',
    minWidth: 80
  },
  {
    prop: 'tenantName',
    label: '租户名称 ',
    minWidth: 80
  },

  {
    prop: 'moduleConfigName',
    label: '加密狗应用名称',
    minWidth: 80
  },
  {
    prop: 'beginTime',
    label: '服务开始日期',
    minWidth: 80
  },
  {
    prop: 'endTime',
    label: '服务结束日期 ',
    minWidth: 80
  },
  {
    prop: 'lastPayTime',
    label: '最后续费时间 ',
    minWidth: 80
  },

  {
    prop: 'applyStatus',
    label: '应用状态 ',
    minWidth: 80
  },
  // {
  //   prop: 'approvalStatus',
  //   label: '审核状态',
  //   minWidth: '80'
  // },
  {
    prop: 'action',
    label: '操作',
    minWidth: 120,
    btnArr: ['stop', 'open', 'charge']
  }
]

export const authApplicationTableScheme = [
  {
    prop: 'appName',
    label: '应用名称',
    minWidth: 80
  },
  {
    prop: 'beginTime',
    label: '授权开始时间',
    minWidth: 80
  },
  {
    prop: 'endTime',
    label: '授权结束时间',
    minWidth: 80
  },
  {
    prop: 'tenantName',
    label: '租户名称',
    minWidth: 80
  },
  { prop: 'clinicName', label: '门诊名称 ', minWidth: 80 },
  {
    prop: 'applyStatus',
    label: '应用状态',
    minWidth: 80
  },
  // {
  //   prop: 'approvalStatus',
  //   label: '审核状态',
  //   minWidth: '80'
  // },
  {
    prop: 'action',
    label: '操作',
    btnArr: ['stop', 'open', 'charge']
  }
]

export const applyApprovalTypes = [
  {
    value: 2,
    label: '到期续费'
  },
  {
    value: 3,
    label: '申请功能升级'
  },
  { value: 4, label: '续费和功能升级' },
  { value: 5, label: '其他' }
]

// 基础设置 form
export const authFormSchemas = [
  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '服务时间',
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'lastPayTime',
    defaultValue: '',
    component: 'Date',
    label: '最后续费时间',
    placeholder: '请选择最后续费时间',
    rules: [
      {
        required: true,
        message: '最后续费时间不能为空'
      }
    ]
  },
  {
    field: 'applyStatus',
    defaultValue: '',
    component: 'Switch',
    disabled: true,
    label: '版本状态',
    rules: []
  },
  {
    field: 'ybCode',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '医保编码',
    rules: []
  },
  {
    field: 'clientNumber',
    type: 'number',
    defaultValue: '',
    disabled: true,
    component: 'Input',
    label: '授权客户端数量',
    placeholder: '请输入授权客户端数量',
    rules: []
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    disabled: true,
    label: '授权版本',
    radioArr: []
  },
  {
    field: 'applyApprovalType',
    defaultValue: 1,
    component: 'Select',
    label: '操作说明',
    disabled: true,
    radioArr: applyApprovalTypes,
    rules: [
      {
        required: true,
        message: '操作说明不能为空'
      }
    ]
  }
]

export const tableDataSchemas = [
  {
    prop: 'tenantName',
    label: '租户名称',
    minWidth: 120
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 120,
    btnArr: ['info']
  }
]

export const infoTableDataSchemas = [
  {
    prop: 'tenantName',
    label: '租户名称',
    minWidth: 120
  },
  {
    prop: 'clinicName',
    label: '门诊名称',
    minWidth: 120
  },
  {
    prop: 'appName',
    label: '应用配置名称',
    minWidth: 120
  },
  {
    prop: 'beginTime',
    label: '授权开始时间',
    minWidth: 120
  },
  {
    prop: 'endTime',
    label: '授权结束时间',
    minWidth: 120
  },
  {
    prop: 'approvalStatus',
    label: '审批进度',
    minWidth: 80
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 120,
    btnArr: ['update', 'approval', 'delete']
  }
]

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Cascader',
    label: '租户',
    placeholder: '请选择租户',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ]
  },

  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '授权时间',
    placeholder: '请选择授权时间',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '应用配置',
    placeholder: '请选择应用配置',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '请选择一个应用不能为空'
      }
    ]
  }
]

// 修改设置 form
export const updateFormSchemas = [
  {
    field: 'tenantName',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '租户名'
  },
  {
    field: 'clinicName',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '诊所名'
  },
  // {
  //   field: 'type',
  //   defaultValue: 1,
  //   component: 'Radio',
  //   label: '所属模块类型',
  //   disabled: true,
  //   placeholder: '请选择所属模块类型',
  //   radioArr: [
  //     {
  //       label: '平台管理系统',
  //       value: 1
  //     },
  //     {
  //       label: 'his管理系统',
  //       value: 2
  //     }
  //   ],
  //   rules: []
  // },

  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '授权时间',
    placeholder: '请选择授权时间',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  }
  // {
  //   field: 'moduleConfig',
  //   defaultValue: '',
  //   component: 'Radio',
  //   label: '应用配置',
  //   placeholder: '请选择应用配置',
  //   disabled: true,
  //   radioArr: [],
  //   rules: [
  //     {
  //       required: true,
  //       message: '请选择一个应用不能为空'
  //     }
  //   ]
  // }
]

export const options = []
